import React from 'react';
import PropTypes from 'prop-types';
import { useSearchResultsActions } from '@sitecore-search/react';

const SearchCard = ({
    itemId,
    itemIndex,
    sourceId,
    cardTitle,
    cardDescription,
    cardLink,
    cardImageUrl
}) => {
    const { onItemClick } = useSearchResultsActions();
    const CardContent = (
        <div className="search-card-row">
            <div className="search-card-image-col">
                {cardImageUrl && (
                    <div className="search-card-image-box">
                        <img src={cardImageUrl} alt={cardTitle} />
                    </div>
                )}
            </div>
            <div className="search-card-content-col">
                <h3 className="search-card-title">{cardTitle}</h3>
                {cardDescription && (
                    <div className="search-card-description">
                        <p>{cardDescription}</p>
                    </div>
                )}

                {cardLink && (
                    <p className="search-card-link">{ cardLink }</p>
                )}
            </div>
        </div>
    );

    return (
        <article className="c-search-card">
            {cardLink ? (
                <a
                    className="search-card-link-wrapper"
                    href={cardLink}
                    onClick={e => {
                        e.preventDefault();
                        onItemClick({
                            id: itemId,
                            index: itemIndex,
                            sourceId
                        });
                        window.location.href = cardLink;
                    }}
                >
                    {CardContent}
                </a>
            ) : (
                {CardContent}
            )}
        </article>
    );
};

SearchCard.propTypes = {
    itemId: PropTypes.string,
    itemIndex: PropTypes.number,
    sourceId: PropTypes.string,
    cardTitle: PropTypes.string.isRequired,
    cardDescription: PropTypes.string,
    cardLink: PropTypes.string,
    cardImageUrl: PropTypes.string
};

export default SearchCard;
